import React from "react";
import { Layout } from "antd";
import { Loading, ScrollToTop, SkipToContent, StaticVersion } from "@networkraildigitalfactory/components";
import AppContext from "../services/appContext";
import Header from "../components/Header/Header";
import pJson from "../../package.json";
import { getBuild } from "../services/utils";

const { version } = pJson;
const { env } = getBuild();

const BaseView = (props) => {
  return (
    <AppContext.Consumer>
      {({
        prevPath,
        title,
        logout,
        loading,
        loadingText,
        user,
        updateUser,
        setUnsavedChanges,
        isLineManager,
        resetSkillFilter,
        setObjectivesFilters,
        isSecondScreen,
        setIsSecondScreen,
        isFirstLogin,
        setFirstLogin,
        isDirtyForm,
        setIsDirtyForm,
        navModalProps,
        setNavModalProps,
        isWhatsNewModalOpen,
        isOnboardingModalOpen,
        setIsOnboardingModalOpen,
        setIsWhatsNewModalOpen,
      }) => (
        <Layout style={{ background: "#fff" }}>
          {window.location.pathname !== "/login" && (
            <SkipToContent id="skipContent" skipToId="tabToMe" />
          )}
          {window.location.pathname !== "/login" && (
            <Header
              prevPath={prevPath}
              title={title}
              logout={logout}
              user={user}
              updateUser={updateUser}
              setUnsavedChanges={setUnsavedChanges}
              isLineManager={isLineManager}
              resetSkillFilter={resetSkillFilter}
              setObjectivesFilters={setObjectivesFilters}
              isSecondScreen={isSecondScreen}
              setIsSecondScreen={setIsSecondScreen}
              isFirstLogin={isFirstLogin}
              setFirstLogin={setFirstLogin}
              isDirtyForm={isDirtyForm}
              setIsDirtyForm={setIsDirtyForm}
              navModalProps={navModalProps}
              setNavModalProps={setNavModalProps}
              isWhatsNewModalOpen={isWhatsNewModalOpen}
              isOnboardingModalOpen={isOnboardingModalOpen}
              setIsOnboardingModalOpen={setIsOnboardingModalOpen}
              setIsWhatsNewModalOpen={setIsWhatsNewModalOpen}
            />
          )}
          <Layout.Content>{props.children}</Layout.Content>
          <Loading loading={loading} loadingText={loadingText} />
          {window.location.pathname !== "/login" && <ScrollToTop />}
          <StaticVersion version={version} show={env !== "PROD"} />
        </Layout>
      )}
    </AppContext.Consumer>
  );
};
export default BaseView;
